import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enGB from '../assets/locales/en_GB.json';
import enUS from '../assets/locales/en_US.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            'en-US': { translation: enUS },
            'en-GB': { translation: enGB },
        },
        fallbackLng: 'en-US',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
